import LxcError from "~/core/models/LxcError.class";
import operationManagerService from "~/core/services/operationManager.service";
import type { DtwinOperation } from "~/modules/dtwin/models/DtwinOperation.interface";
import type { DtwinOperationCertificateInputParameters } from "~/modules/dtwin/models/DtwinOperationCertificateInputParameters.interface";
import type { DtwinUpdateOperation } from "~/modules/dtwin/models/DtwinUpdateOperation.interface";

export function useUpdateOperationRenewCertificate({
  organizationCode,
}: {
  organizationCode?: number;
}) {
  const isLoading = ref(false);
  const error = ref();
  const result: Ref<
    DtwinOperation<DtwinOperationCertificateInputParameters> | undefined
  > = ref();

  async function update(
    uid: string,
    operation: DtwinUpdateOperation<DtwinOperationCertificateInputParameters>,
  ) {
    if (!organizationCode) {
      throw new Error("Organization code is undefined");
    }

    isLoading.value = true;
    error.value = undefined;

    const response = await operationManagerService.updateOperation(
      organizationCode,
      uid,
      operation,
    );

    if (LxcError.check(response)) {
      error.value = response;
    } else {
      result.value =
        response as unknown as DtwinOperation<DtwinOperationCertificateInputParameters>;
    }

    isLoading.value = false;
  }

  return {
    update,
    isLoading,
    error,
    result,
  };
}
